import { avatarColorFor } from '@/shared/lib/avatarColor';

interface AvatarStackProps {
  names: string[];
  max?: number;
}

function initial(name: string): string {
  const trimmed = name.trim();
  return trimmed.length > 0 ? trimmed.charAt(0) : '?';
}

export function AvatarStack({ names, max = 3 }: AvatarStackProps) {
  const visible = names.slice(0, max);
  const remainder = names.length - visible.length;
  return (
    <div className="flex items-center" aria-label={`참여자 ${names.length}명`}>
      {visible.map((name, index) => (
        <span
          key={`${name}-${index}`}
          className="-ml-2 inline-flex h-9 w-9 items-center justify-center rounded-full border-2 border-surface text-small font-semibold text-white first:ml-0"
          style={{ backgroundColor: avatarColorFor(name) }}
          title={name}
        >
          {initial(name)}
        </span>
      ))}
      {remainder > 0 ? (
        <span className="-ml-2 inline-flex h-9 w-9 items-center justify-center rounded-full border-2 border-surface bg-surface-muted text-small font-semibold text-ink">
          +{remainder}
        </span>
      ) : null}
    </div>
  );
}
